<template>
  <Card>
    <template #cardBody>
      <div class="d-flex justify-content-end align-items-center mb-3">
        
      </div>
      <div class="table-responsive row">
        <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4"
               id="event_invitations_datatable">
          <thead class="mb-5">
          <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
            <th class="min-w-100px text-center">{{ $t('events.label.gender') }}</th>
            <th class="min-w-100px text-center">{{ $t('events.label.lastname') }} </th>
            <th class="min-w-100px text-center">{{ $t('events.label.firstname') }}</th>
            <th class="min-w-100px text-center">{{ $t('events.label.email') }} </th>
            <th class="min-w-100px text-center">{{ $t('events.label.status') }} </th>
            <th class="w-100px text-start">{{ $t('label.action') }}</th>
          </tr>
          </thead>
        </table>
      </div>
    </template>
  </Card>
</template>

<script setup>

import Card from "@/components/Card.vue";
import abilities from "@/composables/abilities";
import Ls from "@/services/ls";
import {computed, nextTick, onMounted, ref, watch} from "vue";
import {BASE_URL} from "@/services/api";
import i18n from "@/plugins/i18n";
import {useLocales} from "@/composables/locales";
import {useHasAbility} from "@/composables/hasAbility";
import {useSwal} from "@/composables/useSwal";
import Button from "@/components/Button.vue";
import {useStore} from "vuex";
import AddStatusModal from "@/Modules/Events/components/modals/AddStatusModal.vue";
import {useRoute} from "vue-router";
import AddParticipatorModal from "@/Modules/Events/components/modals/AddParticipatorModal.vue";
import { Theme } from "@/composables/theming";
import UpdateParticipatorModal from "@/Modules/Events/components/modals/UpdateParticipatorModal.vue";
import InputFileIcon from "@/components/InputFileIcon"
import ButtonDropdownFilter from "@/components/ButtonDropdownFilter.vue";

const route = useRoute()
const store = useStore()
const {locale, datatableLocaleUrl} = useLocales()
const { can } = useHasAbility()
const {showSwal} = useSwal()

const table = ref(null)
const status = ref('')

const props = defineProps({
    detail: {
        type: Object, 
        default: {}
    }
})

const eventInvitationStatus = computed(() => store.getters['events/getInvitationStatus'])

watch(() => route.query.tab, (value) => {
  if(value) {
    loadData()
    loadEventInvitations()
  }
});

watch(() => props.detail, (value) => {
    if(value){
      setTimeout(() => {
        loadEventInvitations();
      }, 10000);
    }
}, { deep: true });

function loadEventInvitations() {
  if(can(abilities.VIEW_EVENT_PARTICIPATORS) && route.query.tab === 'tab-invitations') {
    const AUTH_TOKEN = Ls.get('auth.token')

    table.value = $('#event_invitations_datatable').DataTable({
      destroy: true,
      responsive: !0,
      searchDelay: 500,
      processing: !0,
      serverSide: !0,
      pageLength: Ls.get('pageLength') ?? 5,
      lengthMenu: [5, 10, 25, 50, 75, 100 ],
      order: [[ 1, 'desc']],
      ajax: {
        url: BASE_URL + `/event/invitation/${route.params.id}/datatable?status=${status.value}`,
        type: "GET",
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          request.setRequestHeader("Company", Ls.get('current.company'));
        }
      },
      columns: [
        { data: "gender" }, { data: "firstname" }, { data: "lastname" }, { data: "email" }, { data: "status" },{ data: "Actions", responsivePriority: -1 }
      ],
      columnDefs: [
        {
          targets: -6,
          order: "desc",
          className: "dt-center text-center clickable" ,
          render: function (t, a, e, l) {
            let gender = '';
            if(t == 'male'){
              gender = i18n.global.t('user.male')
            }else{
              gender = i18n.global.t('user.female')
            }
            return '<span data-id="'+ e.id +'">' + gender + "</span>";
          },
        },
        {
          targets: -5,
          order: "desc",
          className: "dt-center text-center clickable" ,
          render: function (t, a, e, l) {
            return '<span data-id="'+ e.id +'">' + t + "</span>";
          },
        },

        {
          targets: -4,
          order: "desc",
          className: "dt-center text-center clickable" ,
          render: function (t, a, e, l) {
            return '<span data-id="'+ e.id +'">' + t + "</span>";
          },
        },
        {
          targets: -3,
          orderable: false,
          className: "dt-center text-center clickable" ,
          render: function (t, a, e, l) {
            return '<span data-id="'+ e.id +'">' + t + "</span>";
          }
        },

        {
          targets: -2,
          order: "desc",
          className: "dt-center text-center clickable" ,
          render: function (t, a, e, l) {
            const locale = i18n.global.locale.value
            let color = e.status.color
            let status = e.status[locale]
            return '<span class="badge badge-light-' + color +'" style="font-size:13px; margin:3px; padding:5px"><span style="margin-left: 5px" class="valueRow' + l.row + ' label label-success label-inline font-weight-bolder mr-2 edit_value_btn">' + status + '</span></span>'
          }
        },
        {
        width: "5%",
        targets: -1,
        "className": "dt-center text-start",
        title: "Actions",
        orderable: !1,
        render: (t, a, e, l) => { 
          let render=""
          if(e.status.value == 'FAILED') {
            render+='<a href="javascript:;" data-id="'+ e.id +'"  class="btn btn-sm btn-clean btn-icon resend_btn" title="'+ i18n.global.t('events.invitations.resend') +'"><i  data-id="'+ e.id +'" class="far fa-paper-plane fs-2" style="color: '+Theme.gray +'"></i></a>'
          }
          return render
        },
      },

      ],
      language: {
        url: datatableLocaleUrl.value,
      }
    })

    $(document).on("click", "#event_invitations_datatable .resend_btn", (e) => {
      let id = e.target.getAttribute('data-id') ?? ''
      showSwal(
          '',
          i18n.global.t('events.swal.resend_text'),
          'info',
          '#0072CE'
      ).then( async (result) => {
        if (result.value) {
          store.dispatch('events/resendInvitation', id)
            .then(() => {
                window.toastr['success'](i18n.global.t('events.resend_invitation_successfully'))
                table.value.ajax.reload()
                setTimeout(() => {
                  table.value.ajax.reload()
                }, 10000);
            })
            .catch(() => {
                
            })
        }
      })
    });
  }
}

function loadData() {
  if(route.query.tab === 'tab-invitations') {
    Promise.all([
      store.dispatch('events/loadEventInvitationStatus')
    ])
  }
}

onMounted(() => {
  loadData()
  loadEventInvitations()
})
</script>

<style scoped>
.participator-status-selector {
  background-color: var(--bs-primary)!important;
  color: white;
  border-radius: 8px;
  border: none;
  padding: 0.4rem 0.75rem;
}
</style>